import { Box, Typography, Button } from "@mui/material";
import { Modal, ModalProps } from "./Modal"
import { LoadingButton } from '@mui/lab';
import { useState } from "react";
import { useTask } from "../../hooks/useTask";

export type ConfirmModalProps = Omit<ModalProps, "children"> & {
    title: string;
    description: string;
    icon?: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => Promise<any>;
}

export const ConfirmModal = (props: ConfirmModalProps) => {
    const { title, description, icon, onConfirm, confirmText, cancelText, ...baseProps } = props;

    const [loading, setLoading] = useState(false);

    const handleConfirmTask = useTask(async () => {
        setLoading(true);
        await onConfirm();
        setLoading(false);
        baseProps.onClose();
    });

    const handleClosing = () => {
        if (handleConfirmTask.isRunning) return;
        baseProps.onClose();
    }

    return (
        <Modal {...baseProps} onClose={handleClosing}>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
            }}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    marginBottom: 1,
                }}>
                    {icon && icon}

                    <Typography variant="h4">
                        {title}
                    </Typography>
                </Box>

                <Typography marginBottom={2.5} variant="body1">
                    {description}
                </Typography>

                <Box sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 1,
                }}>
                    {!handleConfirmTask.isRunning && (
                        <Button color="secondary" onClick={handleClosing} variant="text">
                            {cancelText || "Zrušit"}
                        </Button>
                    )}

                    <LoadingButton variant="contained" color="primary" loading={loading} onClick={handleConfirmTask.perform}>
                        {confirmText || "Potvrdiť"}
                    </LoadingButton>
                </Box>
            </Box>
        </Modal>
    );
}